// extracted by mini-css-extract-plugin
module.exports = {"ScrollToTop":"_2BPnT"};